var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5756 5.55175L8.48101 16.051C7.91895 16.6356 7.01966 16.6356 6.4576 16.051L1.42154 10.7677C0.859485 10.1831 0.859485 9.23886 1.42154 8.65432C1.9836 8.06978 2.8829 8.06978 3.44496 8.65432L7.49179 12.881L16.5747 3.43841C17.1367 2.85386 18.036 2.85386 18.5981 3.43841C19.1377 4.02295 19.1377 4.96721 18.5756 5.55175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.dca9cded00a52e21e58aed513f539bc9.svg";
export { ForwardRef as ReactComponent };